import './App.css';
import NavHeader from './components/nav';
import Table from './components/table';

function App() {
  return (
    <div>
      <NavHeader />
      <Table />
    </div>
  );
}

export default App;
